const content = {
  header: 'Thanks! Your password has been reset.',
  firstLine: (firstName, lastName) =>
    `Hi, ${firstName} ${lastName}! Your password has been successfully reset for your Comcast Business account.`,
  secondLine: (email) =>
    `Please use <strong>${email}</strong> and your new password to sign in to My Account and all other Comcast Business applications including the Comcast Business App and the VoiceEdge® desktop app.`,
};

export default content;
